import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import index from '@/components/home/index/index'
import login from '@/components/home/login/login'
import about from '@/components/about/about'
import forgetPassWord from '@/components/home/forgetPassWord/forgetPassWord'
import register from '@/components/home/register/register'
import lIndex from '@/components/home/index/loginIndex'
import documentList from '@/components/home/documentList/documentList'
import documentDetail from '@/components/home/documentList/documentDetail'
import question from '@/components/question/question'
import changePhone from '@/components/userCenter/changePhone'
import userCenter from '@/components/userCenter/userCenter'
import userRz from '@/components/userCenter/userRz'
import paySucc from '@/components/modules/paySucc'
import yq from '@/components/userCenter/yq'
import test from '@/components/test111/test'
import personal from '@/components/userCenter/personal'
import fire from '@/components/fire/fire'
import ffire from '@/components/fire/ffire'
import lxr from '@/components/userCenter/lxr'
import qz from '@/components/userCenter/qz'
import dd from '@/components/userCenter/dd'
import msg from '@/components/userCenter/msg'
import yjfk from '@/components/userCenter/yjfk'
import help from '@/components/userCenter/help'
import helpUserCenter from '@/components/userCenter/help2'
import online from '@/components/online/online'
import pay from '@/components/pay/pay'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: home,
      children: [  //这里就是二级路由的配置
        {
          path: '/',
          name: 'index',
          component: index
        },
        {
          path: '/question/:id',
          name: 'question',
          component: question
        },
        {
          path:'/lIndex',
          name:'lIndex',
          component: lIndex
        },
        {
          path:'/about',
          name:'about',
          component: about
        },
        {
          path:'/online',
          name:'online',
          component: online
        },
        {
          path:'/documentList/:type',
          name:'documentList',
          component:documentList
        },
        {
          path:'/pay',
          name:'pay',
          component: pay
        },
        {
          path:'/userCenter',
          component:userCenter,
          children: [
            {
              path: '/personal',
              name: 'personal',
              component: personal
            },
            {
              path: '/changePhone',
              name: 'changePhone',
              component: changePhone
            },
            {
              path:'/userRz',
              name:'userRz',
              component: userRz
            },
            {
              path:'/paySucc',
              name:'paySucc',
              component: paySucc
            },
            {
              path:'/yq',
              name:'yq',
              component: yq
            },
            {
              path:'/lxr',
              name:'lxr',
              component: lxr
            },
            {
              path:'/qz',
              name:'qz',
              component: qz
            },
            {
              path:'/helpUserCenter',
              name:'helpUserCenter',
              component: helpUserCenter
            },
            {
              path:'/dd',
              name:'dd',
              component: dd
            },
            {
              path:'/msg',
              name:'msg',
              component: msg
            },
            {
              path:'/yjfk',
              name:'yjfk',
              component: yjfk
            }
          ]
        },
        {
          path:'/help',
          name:'help',
          component: help
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/test',
      name: 'testtt',
      component: test
    },
    {
      path: '/forgetPassWord',
      name: 'forgetPassWord',
      component: forgetPassWord
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path:'/fire/:type/:id',
      name:'fire',
      component: fire
    },
    {
      path:'/ffire/:type/:id',
      name:'ffire',
      component: ffire
    },
    {
      path: '*',
      component:index
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js